<template>
  <div>
    <div class="upload-main">
      <label for="file-upload">
        <slot>
          <div class="default-upload pointer">
            <i class="iconfont iconjia"></i>
          </div>
        </slot>
      </label>
      <input type="file" id="file-upload" @change="upload" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'upload',
  data () {
    return {
    }
  },
  methods: {
    upload (e) {
      const file = e.target.files[0]
      this.$emit('change', file)
    },
    download (item) {
    },
    // 文件名字过滤
    filterFileName (name) {
      const specialChar = ['(', ')', '{', '}', '[', ']', '&', '?', '#', '@', '`', ' ']
      return name.split('').filter(n => specialChar.indexOf(n) === -1).join('')
    },
  }
}
</script>

<style lang="less" scoped>
.upload-main {
  display: inline-block;
  vertical-align: top;
  width: 100%;
  label {
    cursor: pointer;
    width: 100%;
    display: inline-block;
  }
}

.default-upload {
  width: 82px;
  height: 82px;
  background-color: #fff;
  border: 1px dashed #C1D9EE;
  border-radius: 6px;
  box-sizing: border-box;
  margin: 0 8px 8px 0;
  display: inline-block;
  line-height: 82px;
  text-align: center;
  i {
    font-size: 42px;
    color: #C1D9EE;
  }
}
/deep/ .el-upload:focus {
  color: #C1D9EE;
}
#file-upload {
  display: none;
}
</style>
